export interface ApplicationName {
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
  noMiddleName?: boolean;
}

/**
 * Saved application names take precedence over the synchronized CSP profile.
 * Empty strings are intentional values; only missing values use the legacy
 * profile fallback. A recorded no-middle-name choice always wins.
 */
export function resolveApplicationName(
  personalDetails?: ApplicationName | null,
  profile?: ApplicationName | null,
): { firstName: string; lastName: string; middleName: string } {
  return {
    firstName: personalDetails?.firstName ?? profile?.firstName ?? '',
    lastName: personalDetails?.lastName ?? profile?.lastName ?? '',
    middleName: personalDetails?.noMiddleName === true ? '' : personalDetails?.middleName ?? profile?.middleName ?? '',
  };
}
